export default function Footer() {
  return (
    <footer className="border-t border-muted bg-muted/30 mt-auto">
      <div className="max-w-3xl mx-auto px-4 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <picture>
              <source srcSet="/images/logo.webp" type="image/webp" />
              <img
                src="/images/logo.png"
                alt="Skyline Roofing & Exteriors"
                width={80}
                height={43}
                className="h-8 w-auto opacity-60"
              />
            </picture>
            <p className="text-xs text-muted-foreground">
              &copy; {new Date().getFullYear()} Skyline Roofing USA. All rights reserved.
            </p>
          </div>
          <p className="text-xs text-muted-foreground text-center sm:text-right max-w-xs">
            Estimates are approximations based on satellite imagery. Final pricing determined after on-site inspection.
          </p>
        </div>
      </div>
    </footer>
  )
}
